module.exports = __webpack_public_path__ + "static/media/cacao-pluck.a1436343.jpg";